import type { ListFieldConfig } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'
import map from 'lodash/map'
import { InventoryBySerialNumberStatusEnum } from '@ztechapps/common.contract'

export const listFieldConfig: ListFieldConfig = {
  transactionRef: { name: 'transactionRef', displayName: 'Transaction Ref.', index: 0, size: 230 },

  code: { name: 'code', displayName: 'Serial Number', index: 1, size: 260 },
  remarks: { name: 'remarks', displayName: 'Remarks', index: 2, size: 550 },

  tags: { name: 'tags', displayName: 'Tags', index: 3, size: 270 },

  status: {
    name: 'status',
    displayName: 'Status',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: map(InventoryBySerialNumberStatusEnum, (item) => item),
    },
    index: 4,
    size: 250,
  },
  batchCode: { name: 'batchCode', displayName: 'Batch Code', index: 5, size: 230, isVisible: false },
} as const satisfies ListFieldConfig
